<template>

  <div  v-if="error" class="timparty-error-modal error-modal modal fade show" :id="modalId" tabindex="-1"  role="dialog" :aria-labelledby="modalId" aria-hidden="true">
    <div :class="'modal-dialog ' + modalClass" role="document">
      <div class="modal-content">
        <span class="float-right p-3">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-if="closeButton" @click="CloseModal">
            <span aria-hidden="true"><img :src="themePath('images/close-modal.png')" class="btn-icon-modal"></span>
          </button>
        </span>
        <div class="p-4 text-center">
        <IconAlert/>

        <h5 class="mt-4 text-black  font-weight-bold">{{ error.title ? error.title : __('Errore') }}</h5>
        <div class="mt-3 text-black " v-html="error.content ? error.content : __('Si è verificato un errore imprevisto') "></div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

    /* eslint-disable */

    import IconAlert from '../assets/images/icon-alert.svg';
    import TimPartyMixin from '../mixins/TimPartyMixin';

    export default {
      name: 'ErrorModal',
      components: { IconAlert },
      mixins: [ TimPartyMixin ],
      props: {

        modalId:{
          type: String,
          required: false,
          default: 'error-modal',
        },
        modalClass:{
          type: String,
          required: false,
          default: 'modal-sm',
        },
        error: {
          type: Object,
          required: false,
        },
        closeButton: {
          type: Boolean,
          required: false,
          default: true,
        },


      },
      data: function(){

        return {

        };

      },
      mounted: function(){


      },

      methods: {
        CloseModal: function(){
          this.$emit('modalClose')
        }
      },
      computed: {

      }
    }
  </script>


